"use client";
import Faq from "react-faq-component";
import "./faq.scss";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Fuse from "fuse.js";
import { fetchFAQs } from "@/slice/faqsSlice";
import { Input } from "@/components/ui/input";

export default function FAQ({ data, faqClassName = "" }) {
  const config = {
    expandIcon: "+",
    collapseIcon: "-",
  };

  const dataFromMainFaqs = useSelector((state) => state.faqs.data);

  const providedFaqRows = Array.isArray(data) ? data : null;
  const faqs = providedFaqRows ? { data: providedFaqRows } : dataFromMainFaqs;
  const dispatch = useDispatch();

  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    // Only fetch FAQs when caller didn't already provide them
    if (!providedFaqRows || providedFaqRows.length === 0) {
      dispatch(fetchFAQs());
    }
  }, [dispatch, providedFaqRows]);

  // useEffect(() => {
  //     if (faqs?.data) {
  //         const fuse = new Fuse(faqs.data, {
  //             keys: ['attributes.title', 'attributes.content'],
  //             includeScore: true,
  //         });

  //         if (query) {
  //             const result = fuse.search(query);
  //             setResults(result.map(({ item }) => item));
  //         } else {
  //             setResults(faqs.data);
  //         }
  //     }
  // }, [query, faqs]);

  const handleInputChange = (e) => {
    setQuery(e.target.value);
  };

  const faqsList =
    providedFaqRows && providedFaqRows.length > 0
      ? {
          rows: providedFaqRows,
        }
      : {
          rows: results.map((i) => ({
            title: i?.title,
            content: i?.content,
          })),
        };

  const styles = {
    bgColor: "transparent",
    titleTextColor: "#2D3748",
    rowTitleColor: "#4A5568",
    rowContentColor: "#718096",
    arrowColor: "#006daf",
  };

  return (
    <div
      className={`faqSectionRoot max-w-4xl mx-auto w-full px-3 py-6 sm:px-4 sm:py-8 md:px-5 md:py-10 lg:py-12 ${faqClassName}`.trim()}
    >
      <div className="text-center mb-6 sm:mb-8 md:mb-10 lg:mb-12">
        <h2 className="text-xl font-bold text-[#006daf] mb-2 sm:text-2xl sm:mb-3 md:text-3xl md:mb-4 lg:text-4xl">
          Frequently Asked Questions
        </h2>
      </div>

      <div className="bg-white rounded-xl shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] divide-y divide-gray-50 sm:rounded-2xl">
        {faqsList && <Faq data={faqsList} config={config} styles={styles} />}
      </div>
    </div>
  );
}
